import React from 'react';
import PrizeCard from 'app/components/reusable/PrizeCard';
import {lootRarity, DEFAULT_RARITY} from 'app/utils/lootboxRarity';
import LootInterface from 'app/interfaces/LootInterface';

interface Props {
    loot: LootInterface[]
    hideName?: boolean
}

const dropChance = (loot: LootInterface): number => Number(loot.chance_percent || 0);

const isZeroChanceCommon = (loot: LootInterface): boolean => lootRarity(loot) === DEFAULT_RARITY && dropChance(loot) === 0;

const compareLoot = (left: LootInterface, right: LootInterface): number => {
    const leftLast = isZeroChanceCommon(left);
    const rightLast = isZeroChanceCommon(right);
    const last = -1;

    if (leftLast !== rightLast) {
        return leftLast ? 1 : last;
    }

    return dropChance(left) - dropChance(right);
};

const sortedLoot = (loot: LootInterface[]): LootInterface[] => [...loot].sort(compareLoot);

const LootboxDetailsPrizes = ({hideName, loot}: Props): React.ReactElement => <div className="prize-card-grid">
    {sortedLoot(loot).map((item: LootInterface, index: number) => <PrizeCard
        key={`${lootRarity(item)}-${index}`}
        loot={item}
        hideName={hideName}
    />)}
</div>;

export default LootboxDetailsPrizes;
